export enum EntityType {
  Incident = 1,
  KeyOrder,
  Repair,
  CommonCase,
  SpaceRenovation,
  Building,
  Lot,
  Space,
  CooperativeSpace,
  MassMessage,
  User,
  Task,
}
